import classNames from 'classnames';
import { useLayoutEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TipTapText } from './TipTapText';
import styles from './TipTapTextExtender.module.scss';

type TipTapTextExtenderProps = {
  content: string;
  maxPixelHeight?: number;
  padding?: 'none' | 'default';
  uuid: string;
  className?: string | undefined;
};

export const TipTapTextExtender = ({
  content,
  maxPixelHeight = 170,
  padding = 'default',
  uuid,
  className,
}: TipTapTextExtenderProps) => {
  const { t } = useTranslation();

  const tipTapRef = useRef<HTMLDivElement | null>(null);

  const [extended, setExtended] = useState<boolean>(false);
  const [canExtend, setCanExpand] = useState<boolean>(false);

  useLayoutEffect(() => {
    if (tipTapRef && tipTapRef.current) {
      const contentHeight = tipTapRef.current.clientHeight;
      setCanExpand(contentHeight >= maxPixelHeight);
    }
  }, [maxPixelHeight]);

  return (
    <div className={classNames(styles['tip-tap-text-extender'], { [styles.padding]: padding !== 'none' })}>
      {canExtend && (
        <input
          type='checkbox'
          id={`expand-toggle-tip-tap-${uuid}`}
          className={styles.checkbox}
          onClick={() => setExtended((prev) => !prev)}
        />
      )}

      <div
        ref={tipTapRef}
        className={styles.content}
        style={{ height: canExtend && !extended ? `${maxPixelHeight}px` : undefined }}
      >
        <TipTapText content={content} padding={padding} className={className} />
      </div>

      {canExtend && (
        <label htmlFor={`expand-toggle-tip-tap-${uuid}`} className={styles.toggle}>
          {extended ? t('tiptap.showLess') : t('tiptap.showMore')}
        </label>
      )}
    </div>
  );
};
